import _ from 'underscore';
import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { withUiBlock } from '@bingads-webui/uiblocker';

const jsData = globalContext.require('component/js-data-campaign/index');
const i18nErrors = globalContext.require('component/api-errors-campaign/index');

// complex fields will impact value of other fields
// or read and write of fields are different schemes
const complexFields = ['EndDate', 'Status', 'AdGroupPercentCpcBid', 'AdGroupCommissionRate'];

export function InlineEditableSave({
  view,
  i18n,
  fieldName,
  updated,
  editorView,
  editorViewCallbackAfterUpdate,
  isDateType = false,
}) {
  const toUpdate = _.pick(updated, 'Id', fieldName);

  // grid load will get date with ISO format: 2018-04-05T00:00:00.000Z,
  // we use bulk upsert api to do inline update, but bulk upsert cannot use the ISO format
  // as MT seems doing some sepcial transformation with this format
  // to fix this, we upsert with a MM/dd/yyyy format, but update grid with ISO format
  if (isDateType) {
    toUpdate[fieldName] = updated[fieldName] ?
      i18n.formatDate(new Date(updated[fieldName]), { raw: 'MM/dd/yyyy', timeZone: 'UTC' }) :
      null;
  }

  toUpdate.Campaign = { Id: updated.Campaign.Id };
  let blockerContainer;

  if (view.isForVNext && view.grid.config.plugins.uiBlocker.el) {
    blockerContainer = view.grid.config.plugins.uiBlocker.el;
  } else {
    blockerContainer = view.grid.gridView.$el;
  }

  jsData.AdGroup
    .update(updated.Id, toUpdate, { adapter: 'bulk' })
    .finally(withUiBlock(blockerContainer))
    .then(() => {
      if (editorViewCallbackAfterUpdate && _.isFunction(editorViewCallbackAfterUpdate)) {
        editorViewCallbackAfterUpdate();
      }

      if (_.contains(complexFields, fieldName)) {
        view.grid.gridView.refresh(true);
      } else {
        view.grid.gridView.trigger('didEdit', updated);
      }
    })
    .catch((response) => {
      const errorMapping = {};
      const unexpectedError = i18n.getString('ErrorNumber_-1');

      if (!response || !response.errors) {
        errorMapping[fieldName] = unexpectedError;
      } else {
        const errors = i18nErrors.getBulkApiErrors(response.errors, 'newadgroup');

        if (!errors || !errors[0] || !errors[0].message) {
          errorMapping[fieldName] = unexpectedError;
        } else {
          errorMapping[fieldName] = errors[0].message;
        }
      }

      if (_.isFunction(editorView.setErrors)) {
        editorView.setErrors(errorMapping);
      } else {
        const alertHelper = new AlertHelper({ i18n });
        alertHelper.showError(errorMapping[fieldName]);
      }
    });
}
